import apiServices from '../../ApiServices/request-handler';
import { requestHandler } from '../../utils/functions';
import { showToast } from '../../utils/utils';
import { setAuthLoading, setCorporateAllTypesDropdowns } from '../slices/authSlice';
import { setClientId, setIsKyc, setKsaCorporate, setNafathCode } from '../slices/constantSlice';
import {
  setApplicationStatus,
  setClientClassificationData,
  setClientClassificationDropdowns,
  setCorpAccOperationInfo,
  setCorpBankInfoData,
  setCorpBankInfoDropdowns,
  setCorpContactInfoData,
  setCorpContactInfoDropdowns,
  setCorpCustodianDetailData,
  setCorpCustodianDetailDropdowns,
  setCorpGeneralInfoData,
  setCorpGeneralInfoDropdowns,
  setCorpInvestmentInfoData,
  setCorpInvestmentInfoDropdowns,
  setCorpLoading,
  setCorpPostLoading,
  setCountriesDropdown,
  setDocumentTypes,
  setKycLoading,
  setSignatureCardDropdownData,
  setTaxSelfCertificationData,
  setTaxSelfCertificationDropdowns,
  setUploadedDocuments,
} from '../slices/corporateSlice';

export const initiateKyc = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setKycLoading,
        apiService: apiServices.initiateKyc,
        param_data: data,
        isErrorMessage: false,
        onDone: (val) => {
          onDone && onDone(val?.result);
        },
      }),
    );
};

export const getGeneralInformationFormData = (clientApplicationId, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: () => apiServices.getGeneralInformationFormData(clientApplicationId),
        setData: setCorpGeneralInfoData,
        setLoading: setCorpLoading,
        onDone: (res) => onDone?.(res),
      }),
    );
};

export const getCorpKycGeneralInfo = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpLoading,
        apiService: apiServices.getCorpKycGeneralInformation,
        param_data: data,
        setData: setCorpGeneralInfoData,
        onDone: onDone,
      }),
    );
};

export const getCorpKycGeneralInfoDropdowns = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getCorpKycGeneralInfoDropdowns,
        param_data: data,
        setData: setCorpGeneralInfoDropdowns,
      }),
    );
};

export const postGeneralInformation = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.postGeneralInformation,
        param_data: data,
        onDone,
      }),
    );
};

export const saveCorpKycGeneralInfo = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.saveCorpKycGeneralInformation,
        param_data: data,
        onDone,
      }),
    );
};

export const getContactInformationFormData = (clientApplicationId) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: () => apiServices.getContactInformationFormData(clientApplicationId),
        setData: setCorpContactInfoData,
        setLoading: setCorpLoading,
      }),
    );
};

export const getCorpKycContactInfo = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpLoading,
        apiService: apiServices.getCorpKycClientPersonalInformation,
        param_data: data,
        onDone: (data) => dispatch(setCorpContactInfoData(data?.result)),
      }),
    );
};

export const postContactInformation = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.postContactInformation,
        param_data: data,
        onDone,
      }),
    );
};

export const saveCorpKycContactInfo = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.saveCorpKycClientPersonalInformation,
        param_data: data,
        onDone,
      }),
    );
};

export const getContactInformationDropdowns = () => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getContactInformationDropdowns,
        setData: setCorpContactInfoDropdowns,
      }),
    );
};

export const getSignatureCard = (clientApplicationId) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getSignatureCard,
        param_data: clientApplicationId,
        setData: setCorpAccOperationInfo,
        setLoading: setCorpLoading,
      }),
    );
};

// Company Acc Operation Screen Apis

export const getSignatureCardDropdown = () => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getSignatureCardDropdown,
        setData: setSignatureCardDropdownData,
      }),
    );
  };
};

export const getCorpKycAccountOperation = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpLoading,
        apiService: apiServices.getCorpKycAccountOperation,
        param_data: data,
        onDone: (data) => dispatch(setCorpAccOperationInfo(data?.result)),
      }),
    );
};

export const saveSignatureCard = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.saveSignatureCard,
        param_data: data,
        onDone,
      }),
    );
};

export const saveCorpKycAccountOperationInfo = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.saveCorpKycAccountOperation,
        param_data: data,
        onDone,
      }),
    );
};

export const getClientClassification = (clientApplicationId) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getClientClassification,
        param_data: clientApplicationId,
        setData: setClientClassificationData,
        setLoading: setCorpLoading,
      }),
    );
};

export const getKycClientClassificationData = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpLoading,
        apiService: apiServices.getCorpKycClientClassification,
        param_data: data,
        onDone: (data) => {
          dispatch(setClientClassificationData(data?.result));
        },
      }),
    );
};

export const saveCorpDocumentClientClassification = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpLoading,
        apiService: apiServices.saveCorpDocumentClientClassification,
        param_data: data,
        onDone,
      }),
    );
};

export const saveClientClassification = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.saveClientClassification,
        param_data: data,
        onDone,
      }),
    );
  };
};

export const saveCorpKycClientInfo = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.saveCorpKycClientClassification,
        param_data: data,
        onDone,
      }),
    );
};

export const getClientClassificationDropdowns = () => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getClientClassificationDropdowns,
        setData: setClientClassificationDropdowns,
      }),
    );
};

export const getInvestmentInformationFormData = (clientApplicationId) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getInvestmentInformationFormData,
        param_data: clientApplicationId,
        setData: setCorpInvestmentInfoData,
        setLoading: setCorpLoading,
      }),
    );
};

export const getCorpKycInvestmentPortfolio = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpLoading,
        apiService: apiServices.getCorpKycInvestmentPortfolios,
        param_data: data,
        onDone: (data) => {
          dispatch(setCorpInvestmentInfoData(data?.result));
        },
      }),
    );
};

export const saveInvestmentInformation = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.saveInvestmentInformation,
        param_data: data,
        onDone,
      }),
    );
};

export const saveCorpKycInvestmentPortfolio = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.saveCorpKycInvestmentPortfolios,
        param_data: data,
        onDone,
      }),
    );
};

export const getInvestmentInformationDropdowns = () => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getInvestmentInformationDropdowns,
        setData: setCorpInvestmentInfoDropdowns,
      }),
    );
};

export const getCustodianDetails = (clientApplicationId) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getCustodianDetails,
        param_data: clientApplicationId,
        setData: setCorpCustodianDetailData,
        setLoading: setCorpLoading,
      }),
    );
};

export const getKycCustodianData = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpLoading,
        apiService: apiServices.getCorpKycClientCustodianInformation,
        param_data: data,
        onDone: (data) => {
          dispatch(setCorpCustodianDetailData(data?.result));
        },
      }),
    );
};

export const saveCustodianDetails = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.saveCustodianDetails,
        param_data: data,
        onDone,
      }),
    );
};

export const saveCorpKycCustodianInfo = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.saveCorpKycClientCustodianInformation,
        param_data: data,
        onDone,
      }),
    );
};

export const getCustodianDetailsDropdowns = () => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getCustodianDetailsDropdowns,
        setData: setCorpCustodianDetailDropdowns,
      }),
    );
};

export const saveBankInformation = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.saveBankInformation,
        param_data: data,
        onDone,
      }),
    );
};

export const saveCorpKycKSABank = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.saveCorpKycKsaBank,
        param_data: data,
        onDone,
      }),
    );
};

export const getBankInformationFormData = (clientApplicationId, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: () => apiServices.getBankInformationFormData(clientApplicationId),
        setData: setCorpBankInfoData,
        setLoading: setCorpLoading,
        onDone,
      }),
    );
};

export const getCorpKycKSABank = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpLoading,
        apiService: apiServices.getCorpKycKsaBank,
        param_data: data,
        setData: setCorpBankInfoData,
        onDone: onDone,
      }),
    );
};

export const getInternationalBankInformationFormData = (clientApplicationId, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getInternationalBankInformationFormData,
        param_data: clientApplicationId,
        setData: setCorpBankInfoData,
        setLoading: setCorpLoading,
        onDone,
      }),
    );
};

export const getCorpKycNonKSABank = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpLoading,
        apiService: apiServices.getCorpKycInternationalBank,
        param_data: data,
        setData: setCorpBankInfoData,
        onDone: onDone,
      }),
    );
};

export const saveInternationBankInformation = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.saveInternationBankInformation,
        param_data: data,
        onDone,
      }),
    );
};

export const saveCorpKycNonKSABank = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.saveCorpKycInternationalBank,
        param_data: data,
        onDone,
      }),
    );
};

export const getBankInformationDropdowns = (onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getBankInformationDropdowns,
        setData: setCorpBankInfoDropdowns,
        onDone,
      }),
    );
};

export const getUploadDocuments = (params, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getUploadDocuments,
        setLoading: setCorpLoading,
        param_data: params,
        onDone: (data) => {
          dispatch(setUploadedDocuments(data?.result?.inputs));
          onDone && onDone(data?.result?.inputs);
        },
      }),
    );
};

export const getKycUploadDocumentVault = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpLoading,
        apiService: apiServices.getKycUploadDocumentVault,
        param_data: data,
        onDone: (data) => {
          dispatch(setUploadedDocuments(data?.result?.inputs));
          onDone && onDone(data?.result?.inputs);
        },
      }),
    );
};

export const getDocumentTypes = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getDocumentTypes,
        param_data: params,
        setData: setDocumentTypes,
      }),
    );
};

export const updateKycDocument = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpLoading,
        apiService: apiServices.updateKycDocument,
        param_data: data,
        onDone,
      }),
    );
};

export const addDocument = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpLoading,
        apiService: apiServices.addDocument,
        param_data: data,
        onDone,
      }),
    );
};

export const getApplicationStatusCorpAccount = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpLoading,
        apiService: apiServices.getApplicationStatusCorpAccount,
        param_data: params,
        onDone: (res) => {
          dispatch(setApplicationStatus(res?.data));
        },
      }),
    );
};

export const getApplicationStatus = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpLoading,
        param_data: data,
        apiService: apiServices.getApplicationStatus,
        setData: setApplicationStatus,
      }),
    );
};

export const submitApplication = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.submitApplication,
        param_data: data,
        setLoading: setCorpPostLoading,
        onDone,
        isSuccessMessage: true,
      }),
    );
};

export const corpKycSubmitApplication = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.corpKycSubmitApplication,
        param_data: data,
        onDone,
      }),
    );
};

export const getTaxSelfCertificationDropdowns = (id) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpLoading,
        apiService: apiServices.getTaxSelfCertificationDropdowns,
        param_data: id,
        onDone: (data) => {
          dispatch(setTaxSelfCertificationDropdowns(data?.result));
        },
      }),
    );
};

export const getTaxSelfCertification = (clientApplicationId) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getTaxSelfCertification,
        param_data: clientApplicationId,
        setData: setTaxSelfCertificationData,
        setLoading: setCorpLoading,
      }),
    );
};

export const getKycTaxCertification = (id) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpLoading,
        apiService: apiServices.getKycTaxCertification,
        param_data: id,
        onDone: (data) => {
          dispatch(setTaxSelfCertificationData(data?.result));
        },
      }),
    );
};

export const saveTaxSelfCertification = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.saveTaxSelfCertification,
        param_data: data,
        onDone,
      }),
    );
};

export const saveKycTaxCertification = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setCorpPostLoading,
        apiService: apiServices.saveKycTaxCertification,
        param_data: data,
        onDone,
      }),
    );
};

export const getCountriesDropdowns = () => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getCountriesDropdowns,
        setData: setCountriesDropdown,
      }),
    );
};

export const postAccountCreation = (data, navigate) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.postAccountCreation,
        param_data: data,
        onDone: (res) => {
          if (data?.applicantTypeId) {
            dispatch(setKsaCorporate(data?.applicantTypeId === 1067));
          }
          dispatch(setClientId(res?.result));
          dispatch(setIsKyc(false));
          navigate('/otp', {
            state: {
              clientId: res?.result,
              data: data,
            },
          });
        },
      }),
    );
  };
};

export const getCorporateAllTypesDropdowns = (isArabic = true) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: isArabic ? apiServices.getCorporateAllTypesArabicDropdowns : apiServices.getCorporateAllTypesDropdowns,
        setData: setCorporateAllTypesDropdowns,
      }),
    );
  };
};

export const corporateClientCredential = (data, navigate) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.corporateClientCredential,
        param_data: data,
        onDone: (res) => {
          navigate('/thank-you');
          // window.location.href = 'http://tharwat-superapp-client-portal-qa.digitrends.pk/#/login?languageId=3';
          // window.location.href = 'https://tharwat-superapp-client-portal-uat.digitrends.us/#/login?languageId=3';
          // window.location.href = 'https://tharwat-superapp-client-portal-staging.digitrends.us/#/login?languageId=3';
        },
      }),
    );
  };
};

export const setClientCredentialsGenerateOtp = (params, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.setClientCredentialsGenerateOtp,
        isSuccessMessage: true,
        param_data: params,
        onDone,
      }),
    );
};

export const deleteDocument = (params, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.deleteDocument,
        param_data: params,
        setLoading: setCorpLoading,
        onDone: (res) => onDone?.(res),
        isSuccessMessage: true,
      }),
    );
};

export const verifyCredentialOtp = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.verifyCredentialOtp,
        param_data: data,
        onDone,
      }),
    );
  };
};

export const verifyWathaq = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        param_data: data,
        apiService: apiServices.verifyWathaq,
        onDone,
        isSuccessMessage: true,
      }),
    );
  };
};

export const createCorpApplication = (params, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        param_data: params,
        apiService: apiServices.createCorpApplication,
        onDone: (data) => {
          onDone && onDone(data);
        },
      }),
    );
  };
};

export const sendCorpNafathVerification = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.sendCorpNafathVerification,
        param_data: data,
        isErrorMessage: false,
        onDone: (data) => {
          dispatch(setNafathCode(data?.data));
          onDone && onDone();
        },
      }),
    );
  };
};

export const getDataFromCorpNafath = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.getDataFromCorpNafath,
        param_data: data,
        isErrorMessage: false,
        onDone: (val) => {
          onDone && onDone();
        },
      }),
    );
  };
};

export const generateAuthToken = (params, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        param_data: params,
        apiService: apiServices.generateAuthToken,
        onDone: (data) => {
          onDone && onDone(data);
        },
      }),
    );
  };
};
